import naja from 'naja';

declare global {
    var zasilkovnaBranchShippingLink: string;
    var packetaCountry: string;
    var packetaWidgetLanguage: string;
    var Packeta: {
        Widget: {
            pick: (apiKey: string, callback: (point: PacketaPoint | null) => void, options?: Record<string, string>) => void;
        };
    };
}

interface PacketaPoint {
    id: number;
    name: string;
    city: string;
    street: string;
    zip: string;
}

export default class ZasilkovnaWidget {
    private static readonly API_KEY = '405597bf1cc5bd08';

    static init(): void {
        ZasilkovnaWidget.initZasilkovna();

        naja.snippetHandler.addEventListener('afterUpdate', (event: { detail: { snippet: { id: string } } }) => {
            if (event.detail.snippet.id.includes('snippet-orderMethodsForm-method') ||
                event.detail.snippet.id.includes('snippet-orderMethodsForm-payments')) {
                ZasilkovnaWidget.initZasilkovna();
            }
        });
    }

    private static initZasilkovna(): void {
        const select = document.querySelector('a.zasilkovna-select');
        if (!select) {
            return;
        }

        const clone = select.cloneNode(true) as HTMLElement;
        select.parentNode?.replaceChild(clone, select);
        clone.addEventListener('click', (e) => {
            e.preventDefault();
            Packeta.Widget.pick(ZasilkovnaWidget.API_KEY, (point: PacketaPoint | null) => {
                if (!point) {
                    return;
                }
                naja.makeRequest('POST', zasilkovnaBranchShippingLink, {
                    'id': point.id,
                }, {
                    history: false,
                });
            }, {
                country: packetaCountry,
                language: packetaWidgetLanguage,
            });
        });
    }
}
